/* eslint-disable */
import Vue          from 'vue'
import Router       from 'vue-router'
import lineProgress from 'nprogress';

// Routers
// import Home     from '@/views/pageHome.vue'
// import About    from '@/views/pageAbout.vue'
// import Articles from '@/views/pageArticles.vue'
// import Events   from '@/views/pageEvents.vue'

const Home     = () => import('@/views/pageHome.vue');
const About    = () => import('@/views/pageAbout.vue');
const Articles = () => import('@/views/pageArticles.vue');
const Events   = () => import('@/views/pageEvents.vue');

import 'nprogress/nprogress.css'

Vue.use(Router)

const mainRouter = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/articles',
      name: 'Articles',
      component: Articles
    },
    {
      path: '/events',
      name: 'Events',
      component: Events
    },
    {
      path: '*',
      redirect: '/'
    }

  ],
  mmode: 'history'
})

mainRouter.beforeResolve((to, from, next) => {
  if (to.name) {
    lineProgress.start()
  }
  next()
})

mainRouter.afterEach((to, from) => {
  lineProgress.done()
})

export default mainRouter
